export default  {
  t1: 'ຈີນິເລກໂນໂລຍ ຄວບຄຸມແລະອີເລກໂນໂລຍ ຄວບຄຸມແລະອີເລກໂນໂລຍ ຄວບຄຸມແລະອີເລກໂນໂລຍ ຄວບຄຸມແລະອີເລກໂນໂລຍບານ',
  t2: 'Copyright© 2019 | ສິດລະບຽບຂະໜາດທີ່ສິດຂອງຈີນິເຄເບີ້ນພື້ນຖານ ຫລື ອົງກອນ, ອົງກອນ, ອົງກອນ, ຍຸກເກດຢ່າງປະກອບສິດ້ວຍສິນເຕີເນັດ ເຊິ່ງລວມຮວມບັນພັ',
  t3: 'ມີປັນຫາດ້ານການເມືອງ',
  t4: 'ຂໍ້ມູດບໍ່ລິການ',
  t5: 'ແຜນງານ',
  t6: 'ໂປຣເເກຣມທົວໄປ',
  t7: 'ໂຕອັກສອນ ໂປຣເເກຣມຂໍ້ມູນທີ່ກ່ຽວຂ້ອງ',
  t8: 'ກໍລະນີຄຸນນະພາບ'
}
